import { render, staticRenderFns } from "./SubmittedSuccess.vue?vue&type=template&id=3bf835a4&scoped=true"
import script from "./SubmittedSuccess.vue?vue&type=script&lang=js"
export * from "./SubmittedSuccess.vue?vue&type=script&lang=js"
import style0 from "./SubmittedSuccess.vue?vue&type=style&index=0&id=3bf835a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf835a4",
  null
  
)

export default component.exports